import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Home from './pages/Home';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
// import Articles from './pages/Articles';
// import ArticleDetail from './pages/ArticleDetail';
import DsaCrashCourse from './pages/DsaCrashCourse';
import QuestionPackages from './pages/QuestionPackages';
import QuestionPackageDetail from './pages/QuestionPackageDetail';
import IDE from './pages/IDE';
import QuestionIDE from './pages/QuestionIDE';
import AIAssistant from './pages/AIAssistant';
import About from './pages/About';
import DashboardPage from './pages/DashboardPage';
import EnrolledCourseContentPage from './pages/EnrolledCourseContentPage';
import SectionLearningPage from './pages/SectionLearningPage';
import AdminPanel from './components/AdminPanel';
import AdminRecordingsPanel from './pages/AdminRecordingsPanel';
import AIInterviewSimulator from './components/AIInterviewSimulator';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import VisitorTracker from './components/VisitorTracker';
import MRIIRSOnboardingModal from './components/MRIIRSOnboardingModal';
import ApiTest from './pages/ApiTest';
import AuthCallback from './pages/AuthCallback';
import TestFeatures from './pages/TestFeatures';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <VisitorTracker />
        <div className="App">
          <Navbar />
          <MRIIRSOnboardingModal />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetail />} />
            {/* <Route path="/articles" element={<Articles />} /> */}
            {/* <Route path="/articles/:id" element={<ArticleDetail />} /> */}
            <Route path="/campus-beats" element={<Navigate to="/dsa-crash-course" replace />} />
            <Route path="/internship" element={<Navigate to="/dsa-crash-course" replace />} />
            <Route path="/dsa-crash-course" element={<DsaCrashCourse />} />
            <Route path="/question-packages" element={<QuestionPackages />} />
            <Route path="/question-packages/:id" element={<QuestionPackageDetail />} />
            <Route path="/ide" element={<IDE />} />
            <Route path="/question-ide" element={<QuestionIDE />} />
            <Route path="/ai-assistant" element={<AIAssistant />} />
            <Route path="/about" element={<About />} />
            <Route path="/api-test" element={<ApiTest />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/test-features" element={<TestFeatures />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/courses/:id"
              element={
                <ProtectedRoute>
                  <EnrolledCourseContentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/courses/:id/sections/:sectionId"
              element={
                <ProtectedRoute>
                  <SectionLearningPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/recordings" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminRecordingsPanel />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/interview-simulator" 
              element={<AIInterviewSimulator />}
            />
            <Route path="/login" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 
